import { render, staticRenderFns } from "./WebsiteBackupsTable.vue?vue&type=template&id=718e38fe&"
import script from "./WebsiteBackupsTable.vue?vue&type=script&lang=ts&"
export * from "./WebsiteBackupsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports